/* this file is automatically generated.  edit at your own peril */
/* copyright 2015 Minted LLC.  All rights reserved */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:template': [],
  'minted:vendor/underscore-1.8.2.min': '_',
})(this, function (m_module, m_template, _) {
var M = m_module.M;

M.Template || (M.Template = {});
M.Template.DeliveryEstimator || (M.Template.DeliveryEstimator = {});

M.Template.DeliveryEstimator.DeliveryEstimatorTool = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n<div class="deliveryEstimatorTool">\n  <div class="">\n    <p class="instructionText">Select your\n      '+
((__t=( productKindOptions ? "product kind and " : "" ))==null?'':__t)+
'\n      options below to see when you will receive your order.\n    </p>\n\n    <div id="deliveryEstimatorToolWrapper">\n      <div class="prefix_1 grid_4">\n        ';
 if (productKindOptions) { 
__p+='\n          <div class="fieldWrapper">\n            <label>Product Kind</label>\n            <select class="productKindPicker">\n              ';
 _.each(productKindOptions, function(label, abbreviation) { 
__p+='\n                ';
 if (model.get("productKindIds") == abbreviation) { 
__p+='\n                  <option selected="selected"\n                    value="'+
((__t=( abbreviation ))==null?'':__t)+
'">'+
((__t=( label ))==null?'':__t)+
'</option>\n                  ';
 } else { 
__p+='\n                    <option value="'+
((__t=( abbreviation ))==null?'':__t)+
'">'+
((__t=( label ))==null?'':__t)+
'</option>\n                  ';
 } 
__p+='\n              ';
 }); 
__p+='\n            </select>\n          </div>\n        ';
 } 
__p+='\n        ';
 if (showExpressServiceCheckbox) { 
__p+='\n          <div class="fieldWrapper expressService">\n            <label>Express Service</label>\n            ';
 if (model.isExpressService()) { 
__p+='\n              <input type="checkbox" checked="checked" />\n            ';
 } else { 
__p+='\n              <input type="checkbox" />\n            ';
 } 
__p+='\n          </div>\n        ';
 } 
__p+='\n        <div class="fieldWrapper">\n          <label>Order Date</label>\n          <input type="text" class="datePicker" />\n          ';
 if (model.hasOrderCutoff()) { 
__p+='\n            <span class="caption captionRight">by 4:30pm Pacific</span>\n          ';
 } else { 
__p+='\n            <span class="caption captionRight">by 8:30pm Pacific</span>\n          ';
 } 
__p+='\n        </div>\n        ';
 if (hasShippingMethodsPicker) { 
__p+='\n          <div class="fieldWrapper">\n            <label>Shipping Option</label>\n            <select class="shippingMethodPicker">\n              ';
 _.each(shippingMethods, function(label, id) { 
__p+='\n                ';
 if (model.get("shippingValueId") == id) { 
__p+='\n                  <option selected="selected"\n                    value="'+
((__t=( id ))==null?'':__t)+
'">'+
((__t=( label ))==null?'':__t)+
'</option>\n                ';
 } else if (label !== undefined) { 
__p+='\n                  <option value="'+
((__t=( id ))==null?'':__t)+
'">'+
((__t=( label ))==null?'':__t)+
'</option>\n                ';
 } 
__p+='\n              ';
 }); 
__p+='\n            </select>\n          </div>\n        ';
 } 
__p+='\n        <p class="internationalShippingMessage">International Orders: Estimated delivery date does not account for local\n          country holidays or unexpected customs delays.</p>\n      </div>\n      <div class="grid_4">\n        <div id="estimatorDate">\n            <div>\n                <label>Your Estimated Delivery Date</label>\n                <h5 class="value">\n                  ';
 if (model.getDeliveredOn()) { 
__p+='\n                    <b>'+
((__t=( M.Date.toDisplayString(model.getDeliveredOn()) ))==null?'':__t)+
'</b>\n                  ';
 } 
__p+='\n                </h5>\n            </div>\n        </div>\n\n      </div>\n    </div>\n\n</div>';
}
return __p;
});

M.Template.DeliveryEstimator.DeliveryEstimatorToolCheckout = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n\n<div id="deliveryEstimatorTool">\n  <div class="box boxCallout bm10">\n    <h5>when will I receive my order?</h5>\n    <div class="separator separatorDotted separator10"></div>\n    <div class="fieldWrapper">\n      <span class="label">Shipping Choice:</span>\n      <span class="value">'+
((__t=( model.get("shipping_method_name") ))==null?'':__t)+
'</span>\n    </div>\n    ';
 if (model.hasCustomerFacingProof()) { 
__p+='\n      <div class="fieldWrapper">\n        <span class="label">We deliver your proof by:</span>\n        <span class="value">\n          ';
 if (model.getProofCreatedOn()) { 
__p+='\n            '+
((__t=( M.Date.toDisplayString(model.getProofCreatedOn()) ))==null?'':__t)+
'\n          ';
 } 
__p+='\n          &nbsp;&nbsp;<a class="whatIsAProofLink">what is a proof?</a>\n        </span>\n      </div>\n      <div class="fieldWrapper proofApprovalDays">\n        <label>You approve your proof in:</label>\n        <select class="proofDaysPicker">\n          ';
 _.each(proofDaysList, function(label, key) { 
__p+='\n            ';
 if (model.get("proofApprovalDays") == key) { 
__p+='\n              <option selected="selected"\n                value="'+
((__t=( key ))==null?'':__t)+
'">'+
((__t=( label ))==null?'':__t)+
'</option>\n            ';
 } else { 
__p+='\n              <option value="'+
((__t=( key ))==null?'':__t)+
'">'+
((__t=( label ))==null?'':__t)+
'</option>\n            ';
 } 
__p+='\n          ';
 }); 
__p+='\n        </select>\n      </div>\n    ';
 } 
__p+='\n    <div class="fieldWrapper">\n      <span class="label">Your order arrives by:</span>\n      <h5 class="value">\n        ';
 if (model.getDeliveredOn()) { 
__p+='\n          <strong>\n            '+
((__t=( M.Date.toDisplayString(new Date(model.getDeliveredOn())) ))==null?'':__t)+
'\n          </strong>\n        ';
 } 
__p+='\n      </h5>\n    </div>\n    <div class="separator separatorDotted separator10"></div>\n    <p class="caption">Some items may arrive before the estimated\n      delivery date.</p>\n    <p class="caption">Please note that the order arrival date includes\n      processing time for your order.</p>\n    <p class="caption">Proofs need to be approved by 8:30 PM Pacific\n      Standard Time. Proofs approved with changes will require one\n      additional day to process. Each additional round of changes made\n      to your proof will require '+
((__t=( model.getProofCreationDaysMessage() ))==null?'':__t)+
'\n      to turn around.\n    </p>\n  </div>\n</div>';
}
return __p;
});


return {};

});
/* end templito generated file */
